@if (siteConfigRule) {
  <div
    class="bg-tertiary d-flex justify-content-between align-items-center bg-light border-start border-warning border-5 p-2 mb-3">
    <div class="d-flex align-items-center">
      <h3 class="fs-6 fw-bold mb-0 me-5">{{ siteConfigRule.name }}</h3>
      @if (siteConfigRule.subid) {
        <p class="mb-0">IF SUBID1 = {{ siteConfigRule.subid }}</p>
      }
    </div>
    @if (!readonly) {
      <div class="d-flex align-items-center">
        <button class="btn btn-outline-warning btn-sm me-2" (click)="updateRule(siteConfigRule)"><i
        class="bi bi-pencil"></i></button>
        <button class="btn btn-outline-danger btn-sm" (click)="deleteRule(siteConfigRule)" appConfirm><i
        class="bi bi-trash"></i></button>
      </div>
    }
  </div>
  <div class="row justify-content-between">
    @for (params of siteConfigParams; track params) {
      <div class="col-5">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span>{{ params.name }} ({{ params.key }}=)</span>
          <div class="d-flex">
            @if (params.key === 'cst' && isParamChecked(siteConfigRule, params)) {
              <i
                (click)="openConsentModeModal(siteConfigRule, params)"
              class="bi bi-pen btn btn-outline-info me-3 py-1"></i>
            }
            <app-input-switch [ngModel]="isParamChecked(siteConfigRule, params)" [ngModelOptions]="{standalone: true}"
              (change)="changeParam(siteConfigRule, params, $event)"
            [disabled]="disabled"></app-input-switch>
          </div>
        </div>
      </div>
    }
  </div>
}
